<script>
/**
 * ****************************************************************************
 * @description     :   Checkbox component
 * @created at      :   2024/05/22
 * @created by      :   ANS903 – phuongdt@ans-asia.com
 * @package         :   Move
 * @copyright       :   Copyright (c) A.N.S Asia
 * @version         :   1.0.0
 * ****************************************************************************
 */

import _ from 'lodash';

/**
 * Import template
 */
import template from './template.html';
import helpers from '@/utils/helpers';

/**
 * Define content of input checkbox component
 */
var AnsCheckbox = {
    template: template,
    props: {
        id: String,
        label: String,
        itemClass: String,
        labelClass: String,
        customizeClass: {
            type: Object,
            default: () => ({})
        },
        inputClass: String,
        value: Array,
        tabindex: {
            type: Number,
            default: 1
        },
        isHorizontal: {
            type: Boolean,
            default: false
        },
        isDecorateDashOption: {
            type: Boolean,
            default: false
        },
        optionNameClass: {
            type: String,
            default: ''
        },
        inputText: {
            type: String,
            default: ''
        },
        modelValue: [Array, String],
        isDisabled: Boolean,
        options: Array,
        optionsDisabled: Array,
        onChange: Function,
        isRequired: Boolean
    },
    emits: ['update:modelValue', 'copyInformationHeadOffice', 'referOptionalInput'],
    data() {
        return {
            text: '',
            modeDisabled: false
        };
    },
    created() {
        if (!['MNG_Client003'].includes(this.$route.name)) {
            this.modeDisabled = helpers.checkAuthorityMode(this.$route.name);
        }
    },
    mounted() {
        this.text = this.inputText;
    },
    watch: {
        modelValue: {
            handler: function (val) {
                if (!(val.includes(String(this.inputKey)) || val.includes(this.inputKey))) {
                    this.text = '';
                    this.$emit('referOptionalInput', this.text);
                }
            },
            deep: true
        },
        inputText(val) {
            this.text = val;
        }
    },
    computed: {
        vewValue() {
            return this.modelValue ? this.modelValue : this.value;
        },
        inputKey() {
            let key = 0;
            this.options.forEach((item) => {
                if (item.input) {
                    key = item.code;
                }
            });
            return key;
        },
        optionHaveInput() {
            return this.options?.find((item) => item.input == true);
        },
        showCheckRequireInput() {
            let flag = false;
            if (this.vewValue.includes(String(this.optionHaveInput.code)) && this.vewValue.length == 1) {
                flag = !!this.text.trim();
            } else {
                flag = !!this.vewValue.length;
            }
            return flag;
        },
        checkDisInput() {
            return this.modelValue.includes(String(this.optionHaveInput.code)) || this.modelValue.includes(this.optionHaveInput.code);
        }
    },
    methods: {
        decorateOption(optionValue) {
            const valueNumbers = this.modelValue.map(Number);
            return valueNumbers.includes(parseInt(optionValue));
        },
        /**
         * disabled item for input checkbox component
         * -----------------------------------------
         * @author : PhuongDT - 2024/05/22 - create
         * @params : id
         * @access : private
         */
        disabledOption(id) {
            if (this.isDisabled) {
                return true;
            }
            const idx = _.indexOf(this.optionsDisabled, id, 0);
            if (idx > -1) {
                return true;
            }
            return false;
        },
        /**
         * selected item for input checkbox component
         * -----------------------------------------
         * @author : PhuongDT - 2024/05/22 - create
         * @params : value
         * @access : private
         */
        selectedOption(val) {
            const idx = _.findIndex(this.vewValue, function (o) {
                return o == val;
            });
            if (idx < 0) {
                return false;
            } else {
                return true;
            }
        },
        /**
         * updated input checkbox component
         * -----------------------------------------
         * @author : PhuongDT - 2024/05/22 - create
         * @params : id
         * @access : private
         */
        updateInput(e) {
            const val = e.target.value;
            const idx = _.indexOf(this.vewValue, val, 0);
            if (idx < 0) {
                this.vewValue.push(val);
            } else {
                this.vewValue.splice(idx, 1);
            }
            this.$emit('update:modelValue', this.vewValue);
            if (this.onChange) {
                this.onChange(e, this.vewValue);
            }
            if (this.optionHaveInput?.code == val) {
                this.$nextTick(() => {
                    var nameInput = 'input_checkbox_' + e.target.id;
                    const input = document.getElementById(nameInput);
                    if (input) {
                        input.focus();
                    }
                });
            }
        },
        updateAddInput() {
            this.$emit('referOptionalInput', this.text);
        }
    }
};
export default AnsCheckbox;
</script>
